import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner'
import { HelperService } from 'src/app/services/helper.service'
import { UserService } from 'src/app/services/user.service'
import { getLoggedUser, setLoggedUser } from 'src/app/_helpers/LocalStorage'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { NotificationService } from 'src/app/services/notification.service'

@Component({
	template: `
		<div
			style="display: flex;
		align-items: center;
		justify-content: center;
		height: 100vh;"
		>
			<ngx-spinner
				class="spinner"
				bdColor="transparent"
				size="medium"
				color="#457720"
				type="ball-scale-multiple"
			>
			</ngx-spinner>
		</div>
	`,
	selector: 'app-redirect'
})
export class RedirectComponent implements OnInit {
	public sessionUser: UserAdmin = getLoggedUser()
	public role: string = ''
	public loggedCompany: boolean = false
	public comingFromCompany: boolean = false

	constructor(
		private router: Router,
		private notificationService: NotificationService,
		private spinner: NgxSpinnerService,
		private helper: HelperService
	) {}

	public ngOnInit(): void {
		this.spinner.show()

		this.comingFromCompany =
			JSON.parse(localStorage.getItem('comingFromCompany')) || false

		this.loggedCompany =
			localStorage.getItem('loggedCompany') === 'true' || false

		if (!this.sessionUser) {
			this.helper.clearLocalStorage()
			this.router.navigate(['/login'])
		} else {
			this.redirectPanel()
		}
	}

	public redirectPanel(): void {
		if (this.sessionUser.status === 'PENDING') {
			setLoggedUser({...this.sessionUser, status: 'ACTIVE'})
			this.router.navigate(['/panel/userDetail'], { queryParams: { changePassword: true} })
			return
		}

		const isUserWithoutCompany = this.sessionUser.roles.some(role => role === 'GENERAL_ADMIN' || role === 'BOTANIC')

		if (this.sessionUser.subModules.length === 0 && !isUserWithoutCompany) {
			this.notificationService.notify('Usuário sem permissionamentos', 400)
			this.helper.clearLocalStorage()
			this.router.navigate(['/login'])

			return
		}

		// redirects to company if back from inside company (Client Request)
		if (this.comingFromCompany) {
			this.router.navigate(['/panel/company'])

			return
		}

		if (isUserWithoutCompany && this.sessionUser.roles.some(role => role === 'BOTANIC')) {
			this.router.navigate(['/panel/species'])
			return
		}

		if (isUserWithoutCompany && !this.loggedCompany) {
			this.router.navigate(['/panel/admin'])

			return
		}

		if (isUserWithoutCompany && this.loggedCompany) {
			this.router.navigate(['/panel/user'])

			return
		}

		const route: string = this.getCustomerRoute()
		this.redirectTo(route)
	}

	public redirectTo(route: string): void {
			this.router.navigate([`/panel/${route}`])
	}

	public getCustomerRoute(): string {
		if (this.sessionUser.subModules.includes('USER')) {
			return this.helper.getRoutesForSubModules('USER')
		}
		if (this.sessionUser.subModules.includes('ADMIN_ARBOLINK')) {
			return this.helper.getRoutesForSubModules('ADMIN_ARBOLINK')
		}
		if (this.sessionUser.subModules.includes('INVENTORY_SCHEDULE')) {
			return this.helper.getRoutesForSubModules('INVENTORY_SCHEDULE')
		}
		if (this.sessionUser.subModules.includes('INVENTORY_HISTORY')) {
			return this.helper.getRoutesForSubModules('INVENTORY_HISTORY')
		}
		if (this.sessionUser.subModules.includes('OPERATION_SERVICE_SCHEDULE')) {
			return this.helper.getRoutesForSubModules('OPERATION_SERVICE_SCHEDULE')
		}
		if (this.sessionUser.subModules.includes('OPERATION_SERVICE_HISTORY')) {
			return this.helper.getRoutesForSubModules('OPERATION_SERVICE_HISTORY')
		}
		if (this.sessionUser.subModules.includes('TREE')) {
			return this.helper.getRoutesForSubModules('TREE')
		}
		if (this.sessionUser.subModules.includes('DASHBOARD')) {
			return this.helper.getRoutesForSubModules('DASHBOARD')
		}
		if (this.sessionUser.subModules.includes('REAL_TIME')) {
			return this.helper.getRoutesForSubModules('REAL_TIME')
		}
		if (this.sessionUser.subModules.includes('COMPANY_SERVICE_PROVIDER')) {
			return this.helper.getRoutesForSubModules('COMPANY_SERVICE_PROVIDER')
		}
		if (this.sessionUser.subModules.includes('CLIENT')) {
			return this.helper.getRoutesForSubModules('CLIENT')
		}
		if (this.sessionUser.subModules.includes('REQUESTER')) {
			return this.helper.getRoutesForSubModules('REQUESTER')
		}
		if (this.sessionUser.subModules.includes('BOTANICAL_KEY')) {
			return this.helper.getRoutesForSubModules('BOTANICAL_KEY')
		}
		if (this.sessionUser.subModules.includes('SPECIE')) {
			return this.helper.getRoutesForSubModules('SPECIE')
		}
		if (this.sessionUser.subModules.includes('PLANTING_SCHEDULE')) {
			return this.helper.getRoutesForSubModules('PLANTING_SCHEDULE')
		}
		if (this.sessionUser.subModules.includes('PLANTING_HISTORY')) {
			return this.helper.getRoutesForSubModules('PLANTING_HISTORY')
		}
		if (this.sessionUser.subModules.includes('APPRAISAL_SCHEDULE')) {
			return this.helper.getRoutesForSubModules('APPRAISAL_SCHEDULE')
		}
		if (this.sessionUser.subModules.includes('APPRAISAL_HISTORY')) {
			return this.helper.getRoutesForSubModules('APPRAISAL_HISTORY')
		}
		if (this.sessionUser.subModules.includes('MANAGEMENT_CONFIGURATION')) {
			return this.helper.getRoutesForSubModules('MANAGEMENT_CONFIGURATION')
		}
		if (this.sessionUser.subModules.includes('OPERATION_FIELD')) {
			return this.helper.getRoutesForSubModules('OPERATION_FIELD')
		}
		if (this.sessionUser.subModules.includes('APPRAISAL_CONFIGURATION')) {
			return this.helper.getRoutesForSubModules('APPRAISAL_CONFIGURATION')
		}
		if (this.sessionUser.subModules.includes('APPRAISAL_REPORT')) {
			return this.helper.getRoutesForSubModules('APPRAISAL_REPORT')
		}
		if (this.sessionUser.subModules.includes('OPERATION_SERVICE_REPORT')) {
			return this.helper.getRoutesForSubModules('OPERATION_SERVICE_REPORT')
		}
		if (this.sessionUser.subModules.includes('REGIONS')) {
			return this.helper.getRoutesForSubModules('REGION')
		}
	}
}
